export class Category {
  constructor() {
    this.id = "";
    this.name = "";
    this.docClass = "personal";
    this.parent = null;
    this.createdBy = "";
  }
}
